import { Link } from "react-router-dom";

import { buttonClass } from "../components/ui/buttonStyles";
import NoticeCard from "../components/ui/NoticeCard";

/** An unknown route. Says which one, so a stale bookmark is diagnosable. */
export default function NotFoundPage() {
  return (
    <NoticeCard
      title="Page not found"
      action={
        <Link to="/sessions" className={buttonClass("outline", "sm")}>
          Back to sessions
        </Link>
      }
    >
      <code className="text-cell">{window.location.pathname}</code> is not a page in this
      dashboard.
    </NoticeCard>
  );
}
